/**
 * Figma MCP asset URLs (expire after ~7 days). Prefer /public assets for production.
 */
export const HomeStaticAssets = {
  appStoreBadge: "/home/mobile-app-store-badge.webp",
  googlePlayBadge: "/home/mobile-google-play-badge.webp",
  /** Slide 1 promo — purple gradient background */
  promoSlide1Bg: "/home/promo-slide1-bg.webp",
  /** Slide 1 promo — overlapping phone mockups (transparent PNG) */
  promoSlide1Phones: "/home/promo-slide1-phones.webp",
  /** Slide 2 promo — green-yellow gradient background */
  promoSlide2Bg: "/home/promo-slide2-bg.webp",
  /** Slide 2 promo — stock list card art */
  promoSlide2Stocklist: "/home/promo-slide2-stocklist.webp",
  /** Akinda AI feature — icon + headline composite */
  akindaAiSection: "/home/akinda-ai-section.webp",
  /** Feature showcase visuals (provided exports) */
  featureShowcase: {
    halalStocksAnalysis: "/home/feature-halal-stocks-analysis.webp",
    topHalal: "/home/feature-top-halal.webp",
    myPortfolio: "/home/feature-my-portfolio.webp",
    akindaAi: "/home/feature-akinda-ai.webp",
  },
  /** Featured in — media logos (node 709:76263) */
  media: {
    yahooFinance: "/home/media-yahoo-finance.webp",
    globeMail: "/home/media-globe-mail.webp",
    digitalJournal: "/home/media-digital-journal.webp",
    businesswire: "/home/media-businesswire.webp",
    barchart: "/home/media-barchart.webp",
    halalWallet: "/home/media-halalwallet.webp",
  },
  /** Trusted broker logos (Figma 731:57026) */
  brokers: [
    "/home/broker-01.webp",
    "/home/broker-02.webp",
    "/home/broker-03.webp",
    "/home/broker-04.webp",
    "/home/broker-05.webp",
    "/home/broker-06.webp",
    "/home/broker-07.webp",
    "/home/broker-08.webp",
    "/home/broker-09.webp",
  ],
  /** MyPortfolio — 3:2 screen mock (design export) */
  portfolioScreen: "/home/portfolio-screen-mock.webp",
  /** Footer (Figma 706:64646) */
  footerLogo: "/home/footer-logo.svg",
  footerSocial: {
    x: "/home/footer-social-x.svg",
    linkedin: "/home/footer-social-li.svg",
    facebook: "/home/footer-social-fb.svg",
    instagram: "/home/footer-social-ig.svg",
    youtube: "/home/footer-social-yt.svg",
    reddit: "/home/footer-social-reddit.svg",
    telegram: "/home/footer-social-tg.svg",
  },
} as const;

/** App store listing URLs (shared by promo + footer). */
export const APP_STORE_URL =
  "https://apps.apple.com/us/app/akinda/id6759177972";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=io.invest.akinda_invest_mobile";

export const FigmaHomeAssets = {
  /** Promo carousel — node 655:48471 & 655:48472 */
  promoCarousel: {
    slide2: {
      background:
        "https://www.figma.com/api/mcp/asset/cc64055d-f5ea-428d-b102-2539b8541f36",
      stockListArt:
        "https://www.figma.com/api/mcp/asset/e1a106bc-8e2a-40b7-837d-be9c8c27e8c0",
    },
  },
  brokers: {
    img2: "https://www.figma.com/api/mcp/asset/8e13d2ba-d8ec-4def-954f-10a12e130bc5",
    img6: "https://www.figma.com/api/mcp/asset/5a69b3bc-3364-4177-ab17-ae806cd05461",
    img31: "https://www.figma.com/api/mcp/asset/97d9aa43-aeb8-4a74-af7a-01832c3e8e43",
    img32: "https://www.figma.com/api/mcp/asset/9ebcdf8c-4297-4af9-87ed-6e508c97edba",
    img4: "https://www.figma.com/api/mcp/asset/5afd98cd-b7c8-4d74-afd7-82e3f401ed87",
    img33: "https://www.figma.com/api/mcp/asset/4074eb2c-18e4-48bb-9901-7f151754e651",
    img36: "https://www.figma.com/api/mcp/asset/6db8e280-502a-4811-b517-da73db4c4f4a",
    img35: "https://www.figma.com/api/mcp/asset/e38accc2-b559-412b-bfbe-41cdd018258b",
    img34: "https://www.figma.com/api/mcp/asset/7e08550e-5d7a-42f0-878d-92b3f14b4f85",
  },
  features: {
    halalAnalysis:
      "https://www.figma.com/api/mcp/asset/255a3bb0-fc47-4a1e-9c52-97edca318fa8",
    topHalal:
      "https://www.figma.com/api/mcp/asset/a20ab87a-ae0f-4afd-9a9a-a0631f05ea46",
    topHalalBadge:
      "https://www.figma.com/api/mcp/asset/99f47e52-c1ac-47c2-8a37-2b7d8db5e25a",
  },
  /** Same files as HomeStaticAssets.media — MCP mirrors for short-lived exports */
  media: {
    img16: "https://www.figma.com/api/mcp/asset/3e25b64c-62d2-4d7f-b432-0a51a695241f",
    img20: "https://www.figma.com/api/mcp/asset/3c31598b-5dd5-4cda-8515-b1ba21199561",
    img22: "https://www.figma.com/api/mcp/asset/46080573-e465-4237-afb3-4ac91ec31d57",
    img28: "https://www.figma.com/api/mcp/asset/9d478d21-6d96-4524-96f6-848f92854ca0",
    img25: "https://www.figma.com/api/mcp/asset/1b59550b-bc51-4b11-aeac-01ce0c019305",
  },
} as const;
